import { type OrderItemConfigurationSchema } from "@/components/OrderItemConfigForm/OrderItemConfigForm.schema";

export const getUniqueAddressesFromOrderItemConfigurationForm = (
  versions: OrderItemConfigurationSchema["versions"]
) => {
  if (!versions) {
    return [];
  }

  const allDispatches = versions
    .flatMap((v) => v.dispatches || [])
    .filter((d) => d?.address?.address);

  const uniqueAddressesMap = allDispatches.reduce(
    (acc, current) => {
      const { address, quantity } = current;

      const key = `${address.recipientName}-${address.address}-${address.postalCode}`;

      const parsedQty = Number(quantity);
      const validQty = Number.isNaN(parsedQty) ? 0 : parsedQty;

      if (acc[key]) {
        acc[key].quantity += validQty;
      } else {
        acc[key] = { ...current, quantity: validQty };
      }

      return acc;
    },
    {} as Record<string, (typeof allDispatches)[number]>
  );

  return Object.values(uniqueAddressesMap);
};
